import {
  CartModification,
  CART_MODIFICATION_NORMALIZER,
} from '@spartacus/cart/base/root';
import {Observable} from 'rxjs';
import {OccCartEntryAdapter} from "@spartacus/cart/base/occ";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class GonvarriCartEntryAdapter extends OccCartEntryAdapter {

  checkoutExpress(
    orderNumber: number,
    userId: string,
    cartId: string
  ): Observable<any> {
    return this.http
      .get(this.getOrderExpressUrl(orderNumber, userId, cartId));
  }

  updateEntryPackage(
    entryNumber: number,
    entryUnit: string,
    numberOfSheets: number,
    lenght: number,
    code: string,
    quantity: number,
    userId: string,
    cartId: string
  ): Observable<CartModification> {
    return this.http.post<CartModification>(this.getUpdateEntryPackageUrl(
      entryNumber,
      entryUnit,
      numberOfSheets,
      lenght,
      code,
      quantity,
      userId,
      cartId
    ), {}).pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
  }

  public gonvarriAdd(
    userId: string,
    cartId: string,
    productCode: string,
    quantity: number = 1,
    numberOfSheets?: number,
    packageWeight: number = 1000,
    isContract?: boolean,
    pickupStore?: string,
    length?: number,
  ): Observable<CartModification> {
    return this.http
      .post<CartModification>(
        this.getAddToCartUrl(
          userId,
          cartId,
          productCode,
          quantity,
          numberOfSheets,
          packageWeight,
          isContract,
          pickupStore,
          length,
        ),
        {}
      )
      .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER));
  }

  getUpdateEntryPackageUrl(
    entryNumber: number,
    entryUnit: string,
    numberOfSheets: number,
    lenght: number,
    code: string,
    quantity: number,
    userId: string,
    cartId: string
  ): string {
    const queryParams = {
      entryNumber,
      entryUnit,
      numberOfSheets,
      productCode: code,
      quantity,
      length: lenght,
      cartId
    }
    return this.occEndpointsService.buildUrl(`gonvarri/users/${userId}/carts/updateNumberOfSheets`, {
      queryParams
    });
  }

  getOrderExpressUrl(
    orderNumber: number,
    userId: string,
    cartId: string,
  ): string {
    return this.occEndpointsService.buildUrl(`orgUsers/${userId}/${cartId}/express/${orderNumber}`)
  }

  getAddToCartUrl(
    userId: string,
    cartId: string,
    productCode: string,
    quantity: number,
    numberOfSheets?: number,
    packageWeight?: number,
    isContract?: boolean,
    pickupStore?: string,
    length?: number
  ): string {
    const queryParams = {
      code: productCode,
      quantity,
      pickupStore,
      numberOfSheets,
      packageWeight,
      isContract,
      length
    }
    return this.occEndpointsService.buildUrl(`orgUsers/${userId}/carts/${cartId}/entries`, {
      queryParams
    })
  }

}
